import React, { useState, useEffect } from "react"; // Add useEffect
import { View, Text, TextInput, StyleSheet, TouchableOpacity, Image } from "react-native";
import { BLACK_COLOR } from "../utils/theme";
import ButtonComponent from "./ButtonComponent";
import RepeatModal from "./RepeatModal";

const Studentsetupappointment = ({ icons, onarrowclick, handleselectionclose, handleback,sessionperweek ,repeatappointmentlimit, handlecreateappointment,repeat_count, options,allocation , tutoraddress, displayRepeat }) => {
  const [selectedSession, setSelectedSession] = useState(1);
  const [sessionType, setSessionType] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState({ repeat: "None" });
  const [isButtonDisabled, setIsButtonDisabled] = useState(true); // New state for button disabled status

  const createstudentdata = {
    session_type: sessionType,
    repeat: selectedOption,
    sessions_per_week: selectedSession,
  };

  // Validate all mandatory fields
  useEffect(() => {
    const isValid =
      sessionType !== "" &&
      selectedSession >= 1 &&
      tutoraddress !== null &&
      tutoraddress !== "";
      
    setIsButtonDisabled(!isValid); // Disable button if any field is invalid
  }, [sessionType, selectedOption, selectedSession, tutoraddress]); // Dependencies

  const onConfirm = (data) => {
    setSelectedOption(data);
  };

  const onCreatePress = (createstudentdata) => {
    if (!isButtonDisabled) {
      handlecreateappointment(createstudentdata);
    }
  };

  const handleSessionInput = (text) => {
    const num = parseInt(text);
    if (!isNaN(num) && num >= 1) {
      setSelectedSession(num);
    } else if (text === "") {
      setSelectedSession(1);
    }
  };
  const modalclose = () =>{

    setModalVisible(false)  }

  return (
    <View style={styles.container} testID="appointment-setting-container">
      {/* Header Section */}
      <View style={styles.headercontainer} testID="session-report-container">
        <View style={styles.header} testID="header">
          <TouchableOpacity style={styles.iconButton} testID="session-appointment-icon">
            <Image source={{ uri: icons.sessionappointment }} style={styles.progressIcon} />
          </TouchableOpacity>
          <Text style={styles.title} testID="session-report-title">CREATE APPOINTMENT</Text>
          <TouchableOpacity onPress={handleselectionclose} style={styles.iconButton} testID="close-button">
            <Image source={{ uri: icons.close }} style={styles.progressIcon} />
          </TouchableOpacity>
        </View>

        <View style={styles.sessionCard} testID="session-info-card">
          <Text style={styles.sessionText} testID="about-session-text">SET UP APPOINTMENT</Text>
          <View style={styles.progressContainer} testID="session-progress">
            <Text style={styles.progressText} testID="session-progress-count">4</Text>
            <Text style={styles.totalText} testID="total-sessions">/4</Text>
            <Image source={{ uri: icons.progress }} style={styles.progressIcon} />
          </View>
        </View>
      </View>

      {/* Form Section */}
      <View style={styles.formContainer} testID="form-container">
        {/* Sessions Per Week */}
        <Text style={styles.label} testID="sessions-per-week-label">Sessions Per Week</Text>
        <View style={styles.inputContainer} testID="sessions-input-container">
          <Image source={{ uri: icons.sessionIcon }} style={styles.icon} testID="sessions-icon" />
          <TextInput
            style={styles.sessionInput}
            value={sessionperweek}
            testID="sessions-input"
            disabled={true}
          />
        </View>
      

        {/* Session Type */}
        <Text style={styles.label} testID="session-type-label">Sessions Type</Text>
        <View style={styles.inputBorder} testID="session-type-border">
          <View style={styles.sessionTypeRow} testID="session-type-row">
            {["Online", "InPerson"].map((type) => (
              <TouchableOpacity
                key={type}
                style={[styles.sessionTypeButton, sessionType === type && styles.selectedSessionType]}
                onPress={() => setSessionType(type)}
                testID={`session-type-button-${type}`}
              >
                <Text
                  style={[
                    styles.sessionTypeText,
                    sessionType === type && { color: '#c7373a' },
                  ]}
                  testID={`session-type-text-${type}`}
                >
                  {type}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
        </View>

        {/* Tutoring Address */}
        {sessionType === "InPerson" && (
  <>
        <Text style={styles.label} testID="tutoring-address-label">Tutoring Address</Text>
        <View style={styles.addressContainer} testID="address-container">
          <Image source={{ uri: icons.address }} style={styles.icon} testID="address-icon" />
          <Text
            style={styles.addressInput}
            numberOfLines={1}
            ellipsizeMode="tail"
            testID="address-input"
          >
            {tutoraddress}
          </Text>
        </View>
        </>
)}

        {displayRepeat != 0 && (
          <View>
            <Text style={styles.label} testID="repeat-label">Repeat</Text>
            <TouchableOpacity
              style={styles.dropdown}
              testID="repeat-dropdown"
              onPress={() => setModalVisible(true)}
            >
              <Image
                source={{ uri: icons.repeat }}
                style={styles.icon}
                testID="repeat-icon"
              />
              <Text style={styles.dropdownText} testID="repeat-text">
                {selectedOption?.repeat || 'Select'}
              </Text>
            </TouchableOpacity>
          </View>
        )}
        

      </View>

      {/* Buttons */}
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', paddingTop: 10 }}>
        <ButtonComponent
          label="Create Appointment"
          onPress={() => onCreatePress(createstudentdata)}
          disabled={isButtonDisabled} // Disable button based on state
          style={[
            { backgroundColor: "#000", paddingVertical: 12, fontFamily: 'GT-Walsheim', width: 330 },
            isButtonDisabled && { backgroundColor: "#ccc" }, // Grey out when disabled
          ]}
          textStyle={[
            { color: "#fff", fontFamily: 'GT-Walsheim' },
            isButtonDisabled && { color: "#888" }, // Dim text when disabled
          ]}
        />
        <ButtonComponent
          label="Back"
          onPress={handleback}
          style={{ backgroundColor: "#E9EDF1", paddingVertical: 12, fontFamily: 'GT-Walsheim', width: 330, marginTop: 16 }}
          textStyle={{ color: "#000", fontFamily: 'GT-Walsheim' }}
        />
      </View>

      <RepeatModal
        isVisible={modalVisible}
        icons={icons}
        onClose={modalclose}
        options={options}
        selectedOption={selectedOption}
        onSelect={(option) => setSelectedOption(option)}
        onConfirm={onConfirm}
        repeatappointmentlimit={repeatappointmentlimit}
        repeat_count={repeat_count}
      />
    </View>
  );
};

// Styles remain the same, no changes needed
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F5F7FA",
    fontFamily: 'GT-Walsheim',
  },
  formContainer: {
    width: 360,
    padding: 16,
    borderRadius: 10,
    elevation: 2,
    alignSelf: "center",
    marginTop: 5,
    fontFamily: 'GT-Walsheim',
  },
  label: {
    fontSize: 14,
    color: BLACK_COLOR,
    marginBottom: 8,
    fontFamily: 'GT-Walsheim-Medium',
  },
  inputContainer: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#D1D5DB",
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 9,
    marginBottom: 12,
    backgroundColor: '#ffffff',
    fontFamily: 'GT-Walsheim',
  },
  sessionInput: {
    flex: 1,
    fontSize: 14,
    color: "#000",
    fontFamily: 'GT-Walsheim',
    outlineStyle: 'none',
  },
  inputBorder: {
    borderWidth: 1,
    borderColor: "#D1D5DB",
    borderRadius: 8,
    padding: 8,
    marginBottom: 12,
    backgroundColor: '#ffffff',
    fontFamily: 'GT-Walsheim',
  },
  sessionRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    fontFamily: 'GT-Walsheim',
  },
  sessionButton: {
    paddingVertical: 5,
    paddingHorizontal: 24,
    backgroundColor: "#ffffff",
    borderRadius: 6,
    borderWidth: 1,
    borderColor: "#D1D5DB",
    fontFamily: 'GT-Walsheim',
  },
  selectedSession: {
    borderColor: '#c7373a',
    borderWidth: 1,
  },
  sessionTexts: {
    fontSize: 14,
    fontWeight: "500",
    color: "#000",
    fontFamily: 'GT-Walsheim',
  },
  sessionTypeRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: '#ffffff',
    fontFamily: 'GT-Walsheim',
  },
  sessionTypeButton: {
    flex: 1,
    paddingVertical: 7,
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#D1D5DB",
    borderRadius: 8,
    marginHorizontal: 4,
    fontFamily: 'GT-Walsheim',
  },
  selectedSessionType: {
    borderColor: '#c7373a',
    borderWidth: 1,
  },
  sessionTypeText: {
    fontSize: 14,
    fontWeight: "500",
    color: "#000",
    fontFamily: 'GT-Walsheim',
  },
  addressContainer: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#D1D5DB",
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 9,
    marginBottom: 12,
    backgroundColor: '#ffffff',
    fontFamily: 'GT-Walsheim',
    width: '100%',
  },
  icon: {
    width: 25,
    height: 25,
    marginRight: 8,
    fontFamily: 'GT-Walsheim',
  },
  addressInput: {
    flex: 1,
    fontSize: 14,
    color: "#000",
    fontFamily: 'GT-Walsheim',
    outlineStyle: 'none',
    overflow: 'hidden',
  },
  headercontainer: {
    backgroundColor: "#0E1525",
    paddingHorizontal: 15,
    paddingVertical: 14,
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    fontFamily: 'GT-Walsheim',
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    fontFamily: 'GT-Walsheim',
  },
  iconButton: {
    backgroundColor: "#2C2F38",
    padding: 5,
    borderRadius: 8,
    fontFamily: 'GT-Walsheim',
  },
  title: {
    color: "white",
    fontSize: 17,
    flex: 1,
    textAlign: "center",
    fontFamily: 'GT-Walsheim-Bold',
  },
  sessionCard: {
    backgroundColor: "#2C2F38",
    padding: 9,
    borderRadius: 8,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginVertical: 10,
    fontFamily: 'GT-Walsheim',
  },
  sessionText: {
    color: "white",
    fontSize: 12,
    fontFamily: 'GT-Walsheim-Bold',
  },
  progressContainer: {
    flexDirection: "row",
    alignItems: "center",
    fontFamily: 'GT-Walsheim',
  },
  progressText: {
    color: "white",
    fontSize: 14,
    fontFamily: 'GT-Walsheim-Bold',
  },
  totalText: {
    color: "gray",
    fontSize: 14,
    fontFamily: 'GT-Walsheim-bold',
  },
  progressIcon: {
    width: 30,
    height: 30,
    marginLeft: 5,
    resizeMode: "contain",
    fontFamily: 'GT-Walsheim',
  },
  dropdown: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#D1D5DB",
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 9,
    backgroundColor: '#ffffff',
    fontFamily: 'GT-Walsheim',
  },
  dropdownText: {
    fontSize: 14,
    fontWeight: "500",
    color: "#000",
    marginLeft: 8,
    fontFamily: 'GT-Walsheim',
  },
});

export default Studentsetupappointment;